'use strict';

(function(z, _) {

    /**
     * Material grid
     */
    z.ProjectsCorporateClientsGrid = z.GridView.extend({

        /**
         * Template download url
         */
        // TEMPLATE_DOWNLOAD_URL: '/material/import/template',

        /**
         * Bounding element
         */
        el: "#page-wrapper",

        /**
         * Events
         *
         * @return {undefined}
         */
        events: function() {
            return _.extend({}, z.FiltersView.prototype.events,{
                "click #add-corporate_clients-modal-btn": "onAddEntry",
                "click .corporate_clients-edit-button": "onEditEntry",
                // "click #import-material-modal-btn": "onImportEntry",
                // "click #material-import-close-button": "closeImportSection",
                // "click #template-download-button": "_downloadTemplate"
            });
        },

        /**
         * Constructor.
         *
         * @return {undefined}
         */
        initialize: function() {
            z.GridView.prototype.initialize.apply(this, arguments);

            this.initializeEvents();
        },

        /**
         * Initialize the events.
         *
         * @return {undefined}
         */
        initializeEvents: function() {

            this.$(".chosen-select").chosen({
                search_contains: true
            });
        },

        /**
         * Get datatable id.
         *
         * @return {string} - datatable id
         */
        getDatatableId: function() {
            return 'page-corporate_clients-datatable';
        },

        /**
         * Get page path.
         *
         * @return {string} - page path
         */
        getPath: function() {
            return 'corporateclients';
        },

        /**
         * Get success message container id.
         * This function will be overridden by every view that will extend the GridView.
         *
         * @return {string} - success message container id
         */
        getSuccessMessageContainerId: function() {
            return 'corporate_clients-success-message';
        },
        // onImportEntry: function (e) {
        //     e.preventDefault();
        //     e.stopImmediatePropagation(); // 🔥 important
        //     this.$("#import-materials-panel").show();
        // },
        //
        // closeImportSection: function (e) {
        //     e.preventDefault();
        //     e.stopImmediatePropagation();
        //     this.$("#import-materials-panel").hide();
        // },
        // onImportEntry: function (e) {
        //     e.stopPropagation();
        //     this.$("#import-materials-panel").show();
        // },
        //
        // closeImportSection: function (e) {
        //     e.stopPropagation();
        //     this.$("#import-materials-panel").hide();
        // },

        /**
         * Redirects to download page.
         * @return {undefined}
         * @private
         */
        _downloadTemplate: function(){

            // var record = this._getFormTemplateRecord();

            // this.model.set(record);
            //
            // if (!this.model.isValid(true)) {
            //
            //     return;
            // }

            var url = this._getMaterialTemplateOriginDownloadUrl();

            window.open(url);
        },
        /**
         * Retrieves the form record.
         * @return {object} The form record
         * @private
         */
        // _getFormTemplateRecord: function(){
        //
        //     return {
        //         type: this.$('#material-import-type-field').val()
        //     };
        // },

        /**
         * Returns the url from where you can download the template.
         * @returns {string} The url
         * @private
         */
        // _getMaterialTemplateOriginDownloadUrl: function(){
        //     return window.location.origin + this.TEMPLATE_DOWNLOAD_URL;
        // },

        /**
         * Get success message text.
         * This function will be overridden by every view that will extend the GridView.
         *
         * @return {string} - success message text variable
         */
        getSuccessMessageText: function() {
            return Translator.trans('js.success_message_corporate_client_form');
        },

        /**
         * Get success event name
         *
         * @return {string} - success event name
         */
        getSuccessEventName: function() {
            return 'corporate_clients.success';
        },


    });

})(window.z = window.z || {}, _);
